import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import "../../scss/navbar.scss";
import { AiOutlineHistory } from "react-icons/ai";
import {
  BiCreditCardFront,
  // BiTrendingUp,
} from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { RiUserSharedLine } from "react-icons/ri";
import {
  TbReportSearch,
  TbTimeline,
  TbToolsKitchen,
  TbCalendarTime,
  TbUser,
  TbMenu2,
  TbFileInvoice,
  // TbLayoutGrid,
} from "react-icons/tb";
import { ImStatsDots } from "react-icons/im";
import {
  MdFastfood,
  MdOutlineInventory
} from "react-icons/md";
import { FaUsersRectangle } from "react-icons/fa6";

const Navbar = () => {
  let navigate = useNavigate();

  const typeCheck = localStorage.getItem("type")

  const logoutUser = () => {
    localStorage.clear();
    navigate("/");
  };

  if (typeCheck === "admin" || typeCheck === "agent") {
    return (
      <div className="navbar-new">
        <nav>
          <Link to="/bill">
            <div className="navbar-icons">
              <FontAwesomeIcon icon={faHome} className="nav-icon" />
              <label>Home</label>
            </div>
          </Link>
          <Link to="/salesreport">
            <div className="navbar-icons">
              <TbReportSearch className="nav-icon" />
              <label>Sales Report</label>
            </div>
          </Link>
          <Link to="/home">
            <div className="navbar-icons">
              <TbToolsKitchen className="nav-icon" />
              <label>Kitchen</label>
            </div>
          </Link>
          <Link to="/customerportal">
            <div className="navbar-icons">
              <AiOutlineHistory className="nav-icon" />
              <label>Customer Portal</label>
            </div>
          </Link>
          <Link to="/stats">
            <div className="navbar-icons">
              <ImStatsDots className="nav-icon" />
              <label>Stats</label>
            </div>
          </Link>
          <Link to="/timeline">
            <div className="navbar-icons">
              <TbTimeline className="nav-icon" />
              <label>Timeline</label>
            </div>
          </Link>
          <Link to="/performance">
            <div className="navbar-icons">
              <TbCalendarTime className="nav-icon" />
              <label>Performance</label>
            </div>
          </Link>
          <Link to="/credit">
            <div className="navbar-icons">
              <BiCreditCardFront className="nav-icon" />
              <label>Credit Center</label>
            </div>
          </Link>
          <Link to="/salescomparison">
            <div className="navbar-icons">
              <MdFastfood className="nav-icon" />
              <label>F&B Comparison</label>
            </div>
          </Link>
          <Link to="/inventory">
            <div className="navbar-icons">
              <MdOutlineInventory className="nav-icon" />
              <label>Inventory</label>
            </div>
          </Link>
          <Link to="/accounting">
            <div className="navbar-icons">
              <TbFileInvoice className="nav-icon" />
              <label>Accounting</label>
            </div>
          </Link>
          {/* <Link to="/tableanalytics">
            <div className="navbar-icons">
              <TbLayoutGrid className="nav-icon" />
              <label>Table Analytics</label>
            </div>
          </Link> */}
          {/* <Link to='/salespredict'>
            <div className="navbar-icons">
              <BiTrendingUp className="nav-icon" />
              <label>Sales Forecast</label>
            </div>
          </Link> */}
          <Link to="/employeeanalysis">
            <div className="navbar-icons">
              <FaUsersRectangle className="nav-icon" />
              <label>Employee</label>
            </div>
          </Link>
          <Link to="/user">
            <div className="navbar-icons">
              <TbUser className="nav-icon" />
              <label>User</label>
            </div>
          </Link>
          <Link to="/menu">
            <div className="navbar-icons">
              <TbMenu2 className="nav-icon" />
              <label>Menu</label>
            </div>
          </Link>
          <div className="navbar-icons" onClick={logoutUser}>
            <RiUserSharedLine className="nav-icon" />
            <label>Logout</label>
          </div>
        </nav>
      </div>
    );
  } else if (typeCheck === "inventory") {
    return (
      <div className="navbar-open">
        <nav>
          <Link to="/inventory">
            <div className="navbar-icons">
              <MdOutlineInventory className="nav-icon" />
              <label>Inventory</label>
            </div>
          </Link>

          <Link to="/menu">
            <div className="navbar-icons">
              <TbMenu2 className="nav-icon" />
              <label>Menu</label>
            </div>
          </Link>

          <div className="navbar-icons" onClick={logoutUser}>
            <RiUserSharedLine className="nav-icon" />
            <label>Logout</label>
          </div>
        </nav>
      </div>
    );
  }

};

export default Navbar;